import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountGetLease1,
  LocationVarKey.AccountGetLease2,
  {
    key: LocationVarKey.AfterNavigateAccountLoginGetLease,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginGetLease1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginGetLease2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Get Lease
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountGetLease1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountGetLease2}
        enableSwitchVar={LocationVarKey.AccountGetLease2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginGetLease}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginGetLease1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginGetLease, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginGetLease2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginGetLease2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
